<template>
    <v-container id="cuotas-ivt">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    dark
                    color="success"
                    class="alineacentro DatosMatriculado"
                  >
                    <strong>CUOTAS DE LA CARRERA</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="6" lg="6">
                    <v-select
                    v-model="filtros.idcarrera"
                    :items="listacarrerasfiltro"
                    label="Carrera"
                    item-text="carrera"
                    item-value="idcarrera"
                    height="20px"
                    v-on:change="SeleccionaCarreraCuota"
                    />
                </v-col>
                <v-col cols="12" md="4" lg="4">
                    <v-select
                    v-model="filtros.anio"
                    :items="listaanios"
                    label="Año"
                    item-text="anio"
                    item-value="anio"
                    height="20px"
                    v-on:change="Listar"
                    />
                </v-col>
                <v-col cols="12" md="2" lg="2">
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Listar"
                    @click="Listar"
                  >
                    <v-icon dark> mdi-magnify </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-data-table
                    :headers="columnas"
                    :items="lista"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    item-key="idcuota"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            @click="AbreGeneraFactura(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="item.idfactura!=null || !item.permitegenerarfactura"
                          >
                            mdi-receipt-text-plus
                          </v-icon>
                        </template>
                        <span>Genera Factura</span>
                      </v-tooltip>
                      &nbsp;
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            @click="AbreReGeneraFactura(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="item.idfactura===null  || !item.permitegenerarfactura || (item.idfactura!=null && item.estadocontable!='FACTURA VENCIDA' && item.estadocontable!='FACTURA ANULADA')"
                          >
                            mdi-receipt-text-send
                          </v-icon>
                        </template>
                        <span>Re-Genera Factura</span>
                      </v-tooltip>
                      &nbsp;
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            @click="ImprimirFactura(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="item.idfactura===null || item.estadocontable==='FACTURA VENCIDA'"
                          >
                            mdi-printer-eye
                          </v-icon>
                        </template>
                        <span>Imprimir Factura</span>
                      </v-tooltip>
                      &nbsp;
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            @click="ImprimirRecibo(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="item.idrecibofactura===null && item.idrecibodirecto===null"
                          >
                            mdi-printer-eye
                          </v-icon>
                        </template>
                        <span>Imprimir Recibo</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:item.estadocontable="{ item }">
                      <v-chip :color="getcolorestadocuota(item.estadocontable)" dark>
                        {{ item.estadocontable }}
                      </v-chip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
        </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialoggenerafactura" persistent max-width="800">
        <v-card>
          <v-card-title class="headline">
            {{ facturaagenerar.idfacturaregenera===0 ? 'Generar Factura' : 'Anular Factura y Volver a Generar' }}
          </v-card-title>
          <v-card-text>
            <v-row row wrap>
              <v-col cols="12">
                <span>Titular para la Factura:</span>
                <v-select
                    v-model="facturaagenerar.idpersonafactura"
                    :items="listapersonasvinculadas"
                    label="Titular"
                    item-text="persona"
                    item-value="idpersona"
                    height="20px"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text v-if="listanovedades.length>0">
            <v-row row wrap>
              <v-col cols="12">
                Novedades del Estudiante que se agregarán a la factura:
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-data-table
                    :headers="columnasnovedades"
                    :items="listanovedades"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    item-key="idnovedad"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                  >
                  </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineacentro">
                <v-btn color="green darken-1" text @click="GenerarFactura">
                  {{facturaagenerar.idfacturaregenera===0 ? 'Generar Factura' : 'Re-Generar Factura'}}
                </v-btn>
                <v-btn
                  color="red darken-1"
                  text
                  @click="dialoggenerafactura = false"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
            <br/>
            <br/>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
            fluid
            class="full-height"
            style="background-color: rgba(255, 255, 255, 0.5)"
        >
            <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
            >
            <v-col class="elementocentrado">
                <v-progress-circular indeterminate color="primary" />
            </v-col>
            </v-row>
        </v-container>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
  </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
export default {
  name: "alumnocuota",
  components: {
    ConfirmDlg: ConfirmDlg
  },
  data() {
    return {
      loading: false,
      usuario: '',
      permisolectura: false,
      permisoescritura: false,
      idrol: 0,
      roles: [],
      nromodulo: 8,
      dialogmensaje: false,
      mensajetitulo: '',
      mensajecuerpo: '',
      mensajehome: false,
      filtros: {
        idcarrera: 0,
        anio: 0
      },
      listaanios: [],
      listacarrerasfiltro: [],
      columnas: [
        {
          text: "Op.",
          value: "actions",
          sortable: false,
          width: 120,
        },
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idcuota",
          width: 55,
        },
        {
          text: "Año",
          align: "center",
          sortable: true,
          value: "anio",
          width: 70,
        },
        {
          text: "Cuota",
          align: "center",
          sortable: true,
          value: "nrocuota",
          width: 70,
        },
        {
          text: "Descripción",
          align: "center",
          sortable: true,
          value: "descripcion",
          width: 150,
        },
        {
          text: "Monto",
          align: "center",
          sortable: true,
          value: "montocuota",
          width: 100,
        },
        {
          text: "Saldo",
          align: "center",
          sortable: true,
          value: "saldo",
          width: 100,
        },
        {
          text: "Vencim 1",
          align: "center",
          sortable: true,
          value: "vencimiento1",
          width: 90,
        },
        {
          text: "Vencim 2",
          align: "center",
          sortable: true,
          value: "vencimiento2",
          width: 90,
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estadocontable",
          width: 110,
        }
      ],
      lista: [],
      dialoggenerafactura: false,
      facturaagenerar: {
        idcuota: 0,
        idalumno: 0,
        idpersonafactura: 0,
        usuario: ''
      },
      listanovedades: [],
      columnasnovedades: [
        {
          text: "Novedad",
          align: "center",
          sortable: true,
          value: "tiponovedad",
          width: 250,
        },
        {
          text: "Alta",
          align: "center",
          sortable: true,
          value: "desde",
          width: 90,
        },
        {
          text: "Baja",
          align: "center",
          sortable: true,
          value: "hasta",
          width: 90,
        },
        {
          text: "Monto",
          align: "center",
          sortable: true,
          value: "montonovedad",
          width: 100,
        }
      ],
      listapersonasvinculadas: []
    };
  },
  mounted() {
    this.loading = true;
    this.roles=[];
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    var rolesuser = localStorage.getItem("rolesuserid").split(',');
    rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
    });
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
        this.loading = false;
        this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
        this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
        this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion===3).length > 0 ? true : false;
        var usuario= this.usuario
        axios.get('alumno/carrerasalumno/0/' + usuario + '/0/0')
          .then((result) => {
            if(result.data.resultado===0){
              this.listacarrerasfiltro = result.data.datos;
              if(this.listacarrerasfiltro.length>0){
                this.filtros.idcarrera=this.listacarrerasfiltro[0].idcarrera;
                var ia= 0;
                var anioactual= (new Date()).getFullYear()+1;
                this.listaanios=[];
                for(ia=this.listacarrerasfiltro[0].anioingreso; ia<=anioactual;ia++){
                  this.listaanios.push({anio: ia});
                }
                if(this.listaanios.length>0){
                  this.filtros.anio=(new Date()).getFullYear();
                }
              }
              var idpersona= parseInt(localStorage.getItem('idpersona'));
              axios.get('alumno/responsablesvinculadosfactura/ / /' + idpersona + '/0')
                .then((result) => {
                  if(result.data.resultado===0) {
                    this.listapersonasvinculadas = result.data.datos;
                    //this.loading=false;
                    this.Listar();
                  }else{
                    this.loading = false;
                    this.MostrarMensaje('Error', result.data.resultadomensaje, false);
                  }
                }).catch((error) => {
                    this.loading = false;
                    this.MostrarMensaje('Error', error, false);
                });
            }else{
              this.loading = false;
              this.MostrarMensaje('Error', result.data.resultadoMensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje('Error', error, false);
          });
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    Listar (mensaje) {
      this.loading=true;
      var param= JSON.stringify({idalumno: parseInt(localStorage.getItem('idpersona')), idcarrera: parseInt(this.filtros.idcarrera), anio: parseInt(this.filtros.anio) });
      axios.post("contable/PostCuotasCliente", param, { headers: {"Content-Type": "application/json", }})
        .then((result) => {
          if(result.data.resultado===0){
            this.lista = result.data.datos;
            if(mensaje.length>0){
              this.loading=false;
              this.MostrarMensaje("Error", mensaje, false);
            }else{
              this.loading=false;
            }
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
      })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
      });
    },
    AbreGeneraFactura (item) {
      this.facturaagenerar= {
        idcuota: parseInt(item.idcuota),
        idalumno: parseInt(localStorage.getItem('idpersona')),
        idpersonafactura: parseInt(localStorage.getItem('idpersona')),
        idfacturaregenera: 0,
        idregistrocuotamatricula: item.idregistrocuotamatricula,
        usuario: this.usuario
      };
      this.listanovedades= item.novedades;
      this.dialoggenerafactura=true;
    },
    GenerarFactura () {
      this.loading=true;
      const factura = JSON.stringify(this.facturaagenerar);
      if(this.facturaagenerar.idfacturaregenera===0) {
          axios.post("contable/PostFacturaCliente", factura, { headers: {"Content-Type": "application/json", }}).then((result) => {
            var d = result.data;
            if (d.resultado === 0) {
              this.dialoggenerafactura=false;
              this.Listar('');
            } else {
              var mensaje = "";
              var facturaguardada = false;
              if (d.resultado === 1 || d.resultado === 99) {
                //Error al generar factura en BD
                mensaje = d.resultadomensaje;
              } else if (d.resultado === 2) {
                //OK generar factura en BD pero Error al intentar informar al AFIP
                facturaguardada = true;
                mensaje= d.resultadomensaje;
              }
              if (facturaguardada === false) {
                this.loading = false;
                this.MostrarMensaje("Error", mensaje, false);
              } else {
                this.dialoggenerafactura=false;
                this.Listar(mensaje);
              }
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
        }else{
          axios.post("contable/PostRegeneraFacturaCliente", factura, { headers: {"Content-Type": "application/json", }})
            .then((result) => {
              var d = result.data;
              if (d.resultado === 0) {
                this.dialoggenerafactura=false;
                this.Listar('');
              } else {
                var mensaje = "";
                var facturaguardada = false;
                if (d.resultado === 1 || d.resultado === 99) {
                  //Error al generar factura en BD
                  mensaje = d.resultadomensaje;
                } else if (d.resultado === 2) {
                  //OK generar factura en BD pero Error al intentar informar al AFIP
                  facturaguardada = true;
                  mensaje= d.resultadomensaje;
                }
                if (facturaguardada === false) {
                  this.loading = false;
                  this.MostrarMensaje("Error", mensaje, false);
                } else {
                  this.Listar(mensaje);
                }
              }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
        }
    },
    ImprimirFactura (item) {
      this.loading = true;
      this.exportarFactura(item.idfactura);
    },
    exportarFactura (idfactura) {
      this.loading = true;
      var idrep = 1;
      axios.post("reportes/GetReporte",
        {idreporte: idrep, formato: "PDF",nromodulo: parseInt(this.nromodulo), usuario: this.usuario.toString(), listaparametros: [{ orden: 1, nombre: "idfactura", valor: idfactura.toString() }] },{ headers: { "Content-Type": "application/json" }})
        .then((result) => {
          if (result.data.toString().startsWith("Error") === false) {
            this.loading = false;
            window.open(result.data, "_blank");
          } else {
            this.loading = false;
            this.MostrarMensaje("Error", result.data, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    ImprimirRecibo (item) {
      this.loading = true;
      this.exportarRecibo(item.idrecibofactura!=null ? item.idrecibofactura : item.idrecibodirecto);
    },
    exportarRecibo (idrecibo) {
      this.loading = true;
      var idrep = 2;
      axios.post("reportes/GetReporte", {idreporte: idrep, formato: "PDF",nromodulo: parseInt(this.nromodulo), usuario: this.usuario.toString(), listaparametros: [{ orden: 1, nombre: "idrecibo", valor: idrecibo.toString() }] },{ headers: { "Content-Type": "application/json" }})
        .then((result) => {
          if (result.data.toString().startsWith("Error") === false) {
            this.loading = false;
            window.open(result.data, "_blank");
          } else {
            this.loading = false;
            this.MostrarMensaje("Error", result.data, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    AbreReGeneraFactura (item) {
      this.facturaagenerar= {
        idcuota: parseInt(item.idcuota),
        idalumno: parseInt(localStorage.getItem('idpersona')),
        idpersonafactura: parseInt(item.idpersonafactura),
        idfacturaregenera: item.idfactura,
        usuario: this.usuario
      };
      this.listanovedades= item.novedades;
      this.dialoggenerafactura=true;
    },
    getcolorestadocuota(estado){
      if (estado === 'SIN ABONAR') {return "grey";}
      else if (estado === 'FACTURA GENERADA') {return "green";}
      else if (estado === 'FACTURA REGENERADA') {return "green";}
      else if (estado === 'FACTURA ABONADA') {return "blue";}
      else if (estado === 'FACTURA VENCIDA') {return "red";}
      else if (estado === 'FACTURA ANULADA') {return "black";}
    },
    SeleccionaCarreraCuota () {
      var ia= 0;
      var anioactual= (new Date()).getFullYear()+1;
      this.listaanios=[];
      if(this.listacarrerasfiltro.filter(c=>c.idcarrera===this.filtros.idcarrera)[0].anioingreso<=anioactual){
        for(ia=this.listacarrerasfiltro.filter(c=>c.idcarrera===this.filtros.idcarrera)[0].anioingreso; ia<=anioactual;ia++){
          this.listaanios.push({anio: ia});
        }
      }else{
        for(ia=anioactual; ia<=this.listacarrerasfiltro.filter(c=>c.idcarrera===this.filtros.idcarrera)[0].anioingreso+1;ia++){
          this.listaanios.push({anio: ia});
        }
      }
    }
},
  computed: {
    /* fechalocalfecnac: function () {
      if (this.edited.fechanac != null && this.edited.fechanac != "") {
        var fecha = new Date(this.edited.fechanac);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    }, */
  },
};
</script>
<style>
.letraroja {
  color: red;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>